import { render, staticRenderFns } from "./PaotangCallbackView.vue?vue&type=template&id=592ce90d"
import script from "./PaotangCallbackView.vue?vue&type=script&lang=js"
export * from "./PaotangCallbackView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports